import React, { useState, useEffect, useContext } from "react";
import { ReactComponent as Search } from "../../assets/search.svg";
import Script from "../../assets/script.svg";
import NavBar from "../../components/NavBar/NavBar";
import SideBar from "../../components/SideBar/SideBar";
import { useLocation, useNavigate } from "react-router-dom";
import Highlighter from "react-highlight-words";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { createDoc } from "../../utils/pdfDoc";
import {
  editUpload,
  getUploadDetailByID,
  highlightUpload,
} from "../../services/uploadService";
import {
  getAllPrompts,
  getAllPromptsWithoutPagination,
} from "../../services/promptService";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import Tooltip from "../../components/ToolTip/ToolTip";
import {
  summarizeBastionUpload,
  summarizeOpenAIUpload,
} from "../../services/summaryService";
import AuthContext from "../../store/AuthContext";
import { filterAndReplace } from "../../utils/filterAndReplace";
import { formatText } from "../../utils/formatText";
import MagicalIcon from "../../assets/magical.png";
import AI from "../../assets/image001.png";
import { RotatingLines } from "react-loader-spinner";
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

const UploadDetailScreen = () => {
  const { state } = useLocation();
  const metaData = JSON.parse(state?.metaData)?.info;
  const navigate = useNavigate();
  const [searchWord, setSearchWord] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [messages, setMessages] = useState([]);
  const [prompts, setPrompts] = useState([]);
  const [prevChat, setPrevChat] = useState([]);
  const [transcriptDetail, setTranscriptDetail] = useState({});
  const [toBeHighlighted, setToBeHighlighted] = useState(null);
  const [fetchSummary, setFetchSummary] = useState(false);
  const [includeSummary, setIncludeSummary] = useState(false);
  const [editIdx, setEditIdx] = useState(null);
  const [editValue, setEditValue] = useState("");
  const [edit, setEdit] = useState(null);
  const location = useLocation();
  const authCtx = useContext(AuthContext);
  const [inputValue, setInputValue] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    if (value.startsWith("/")) {
      setShowDropdown(true);
    } else {
      setShowDropdown(false);
    }
  };

  const handlePromptSelect = (prompt) => {
    setInputValue(prompt.promptText);
    setShowDropdown(false);
  };

  useEffect(() => {
    const getTranscripts = async () => {
      try {
        const res = await getUploadDetailByID(location.search.substring(1));
        if (res?.status === "success") {
          console.log(res.result);
          setLoading(false);
          setTranscriptDetail(res?.result);
          setPrevChat(
            filterAndReplace(
              JSON.parse(
                res?.result?.chatGptTextArray
                  ? res?.result?.chatGptTextArray
                  : "[]"
              ),
              ".Format the response nicely,using ** for bold,- for list items etc"
            )
          );
          setMessages(
            res?.result?.transcript ? JSON.parse(res?.result?.transcript) : []
          );
        } else throw new Error("Fetching Failed");
      } catch (e) {
        setLoading(false);
        toast(
          e?.response?.data?.message
            ? e?.response?.data?.message
            : "An error occured. Please try again"
        );
      }
    };

    if (loading) getTranscripts();
    // eslint-disable-next-line
  }, [loading]);

  useEffect(() => {
    const getPrompts = async () => {
      try {
        const res = await getAllPromptsWithoutPagination();
        if (res?.status === "success") {
          setPrompts(res?.result ? res?.result : []);
        } else throw new Error("Fetching Prompts Failed");
      } catch (e) {
        toast(
          e?.response?.data?.message
            ? e?.response?.data?.message
            : "An error occured. Please try again"
        );
      }
    };
    getPrompts();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const updateTranscripts = async () => {
      try {
        const res = await highlightUpload({
          id: location.search.substring(1),
          index: toBeHighlighted,
        });
        if (res?.status === "success") {
          setToBeHighlighted(null);
        } else throw new Error("Fetching Failed");
      } catch (e) {
        setLoading(true);
        setToBeHighlighted(null);
        toast(
          e?.response?.data?.message
            ? e?.response?.data?.message
            : "An error occured. Please try again"
        );
      }
    };

    if (toBeHighlighted !== null) updateTranscripts();
    // eslint-disable-next-line
  }, [toBeHighlighted]);

  useEffect(() => {
    const updateTranscripts = async () => {
      try {
        const res = await editUpload(edit);
        if (res?.status === "success") {
          setEdit(null);
          setLoading(true);
        } else throw new Error("Fetching Failed");
      } catch (e) {
        setLoading(true);
        setEdit(null);
        toast(
          e?.response?.data?.message
            ? e?.response?.data?.message
            : "An error occured. Please try again"
        );
      }
    };

    if (edit !== null) updateTranscripts();
    // eslint-disable-next-line
  }, [edit]);

  useEffect(() => {
    const updateTranscripts = async () => {
      try {
        if (inputValue === "") {
          toast("Please enter a propmt !!!");
          setFetchSummary(false);
          return;
        }

        let res = null;

        if (authCtx?.user?.AI === "BASTIONGPT") {
          res = await summarizeBastionUpload({
            id: location.search.substring(1),
            prompt: inputValue,
          });
        } else {
          res = await summarizeOpenAIUpload({
            id: location.search.substring(1),
            prompt: inputValue,
          });
        }

        //  res = await summarizeBastionUpload({
        //   id: location.search.substring(1),
        //   prompt: inputValue,
        // });

        if (res?.status === "success") {
          setTranscriptDetail(res?.result);
          setPrevChat(
            filterAndReplace(
              JSON.parse(
                res?.result?.chatGptTextArray
                  ? res?.result?.chatGptTextArray
                  : "[]"
              ),
              ".Format the response nicely,using ** for bold,- for list items etc"
            )
          );
          setMessages(
            res?.result?.transcript ? JSON.parse(res?.result?.transcript) : []
          );
          setFetchSummary(false);
          setInputValue("");
        } else throw new Error("Summarizing Failed");
      } catch (e) {
        setFetchSummary(false);
        setInputValue("");
        toast(
          e?.response?.data?.message
            ? e?.response?.data?.message
            : "An error occured. Please try again"
        );
      }
    };

    if (fetchSummary === true) updateTranscripts();

    // eslint-disable-next-line
  }, [fetchSummary]);

  return (
    <>
      <ToastContainer />
      <NavBar />
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "200px 1fr",
          height: "100vh",
        }}
      >
        <SideBar />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            background: "#fff",
          }}
        >
          <div
            style={{
              padding: "20px 50px",
              display: "flex",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                height: "30px",
                width: "30px",
                background: "#f8f8f8",
                borderRadius: "50%",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                aspectRatio: "1",
              }}
              onClick={() => {
                window.history.back();
              }}
            >
              <ion-icon
                name="arrow-back-outline"
                style={{ height: "20px", width: "20px" }}
              ></ion-icon>
            </div>

            <div
              style={{
                display: "flex",
                height: "30px",
                justifyContent: "center",
                flexDirection: "column",
                marginLeft: "30px",
                width: "100%",
              }}
            >
              <div
                style={{
                  fontSize: "15px",
                  fontWeight: "600",
                  textAlign: "left",
                }}
              >
                {metaData.original_filename}.{metaData.format}
              </div>
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "300",
                  textAlign: "left",
                  display: "flex",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "2px",
                  }}
                >
                  <ion-icon name="calendar-clear-outline"></ion-icon>{" "}
                  {moment(metaData.created_at).format("dddd MMMM Do")}
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "2px",
                  }}
                >
                  <ion-icon name="time-outline"></ion-icon>{" "}
                  {moment(metaData.created_at).format("h:mm a")}
                </div>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                width: "450px",
                height: "40px",
                background: "white",
                borderRadius: 5,
                border: "1px solid #bdbdbd",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <input
                type="text"
                value={searchWord}
                onChange={(e) => setSearchWord(e.target.value)}
                placeholder="Search Across The Transcript"
                style={{ height: "38px", color: "rgba(126, 137, 168, 1)" }}
              />
              <Search style={{ marginRight: 10 }} />
            </div>

            <div style={{ position: "relative" }}>
              <div
                style={{
                  display: "flex",
                  width: "80px",
                  height: "40px",
                  background: "white",
                  borderRadius: 5,
                  marginLeft: "20px",
                  border: "1px solid rgba(110, 117, 255, 1)",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "rgba(110, 117, 255, 1)",
                  cursor: "pointer",
                  position: "relative",
                }}
                onClick={() => {
                  setIsOpen((open) => !open);
                }}
              >
                Export
              </div>
              {isOpen && (
                <div className="exportDD">
                  Export Transcript
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      fontSize: 10,
                      margin: "5px 0",
                      width: "100%",
                      gap: 8,
                    }}
                  >
                    <input
                      type="checkbox"
                      style={{
                        padding: 0,
                        flex: "none",
                        borderRadius: 10,
                        height: "10px",
                        width: "20px",
                        margin: "5px",
                      }}
                      className="summaryCheckbox"
                      checked={includeSummary}
                      onChange={() => {
                        setIncludeSummary(
                          !includeSummary &&
                            transcriptDetail.summarizedTranscript !== ""
                        );
                      }}
                    ></input>{" "}
                    Include Summary
                  </div>
                  <p style={{ fontSize: "12px", color: "#333" }}>
                    Select Format
                  </p>
                  <select>
                    <option>PDF</option>
                  </select>
                  <button
                    style={{
                      color: "white",
                      width: "100%",
                      marginTop: "10px",
                      padding: "5px 0",
                      borderRadius: "5px",
                      border: "none",
                      background:
                        "linear-gradient(90deg, #6E75FF 0%, #C66EFF 100%)",
                    }}
                    onClick={() => {
                      var doc = createDoc({
                        file: `${metaData.original_filename}.${metaData.format}`,
                        time: moment(transcriptDetail.createdAt).format("LLLL"),
                        messages,
                        includeSummary,
                        summarizedTranscript:
                          transcriptDetail.summarizedTranscript,
                        url: authCtx?.user?.organization?.imageData,
                      });
                      pdfMake.createPdf(doc).open();
                    }}
                  >
                    Export
                  </button>
                </div>
              )}
            </div>
          </div>

          <div style={{ background: "#fff", flex: 1 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "15px",
                boxShadow: " 0px -1px 0px 0px #EEEEEE inset",
                paddingLeft: "30px",
                color: "#707070",
                fontSize: "15px",
                fontWeight: "500",
                background: "#f8f8f8",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  fontSize: "15px",
                  fontWeight: "500",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    fontSize: "15px",
                    fontWeight: "500",
                    alignItems: "center",
                  }}
                >
                  <img src={Script} alt="Script"></img>
                  Transcript
                  <Tooltip content="Copy Transcript" direction="top">
                    <button
                      style={{
                        marginLeft: 5,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        border: "none",
                        cursor: "pointer",
                      }}
                      onClick={async () => {
                        document.body.style.cursor = "wait";

                        async function copyToClipboard(text) {
                          try {
                            await navigator.clipboard.writeText(text);
                            toast("Copied to clipboard successfully!!");
                          } catch (err) {
                            console.error("Failed to copy text:", err);
                            toast("Failed to copy text:" + err);
                          }
                        }

                        await copyToClipboard(
                          messages.map((arr) => arr.text).join(" ")
                        );
                        document.body.style.cursor = "default";
                      }}
                    >
                      {" "}
                      <ion-icon
                        name="copy-outline"
                        style={{ fontSize: 16, color: "gray" }}
                      ></ion-icon>
                    </button>
                  </Tooltip>
                  <Tooltip content="Use InteliDoc-AI" direction="top">
                    <button
                      onClick={() => {
                        const data = localStorage.getItem("defaultPrompt");

                        console.log(data);

                        if (data) {
                          const defaultPrompt = prompts.filter(
                            (item) => item.id === data
                          );

                          if (defaultPrompt.length > 0) {
                            navigate("/InteliDoc-GPT", {
                              state: {
                                transcription: messages
                                  .map((arr) => arr.text)
                                  .join(" "),
                                prompt: defaultPrompt[0],
                              },
                            });
                          } else {
                            if (prompts.length > 0) {
                              navigate("/InteliDoc-GPT", {
                                state: {
                                  transcription: messages
                                    .map((arr) => arr.text)
                                    .join(" "),
                                  prompt: prompts[0],
                                },
                              });
                            } else {
                              navigate("/InteliDoc-GPT", {
                                state: {
                                  transcription: messages
                                    .map((arr) => arr.text)
                                    .join(" "),
                                },
                              });
                            }
                          }
                        } else {
                          if (prompts.length > 0) {
                            navigate("/InteliDoc-GPT", {
                              state: {
                                transcription: messages
                                  .map((arr) => arr.text)
                                  .join(" "),
                                prompt: prompts[0],
                              },
                            });
                          } else {
                            navigate("/InteliDoc-GPT", {
                              state: {
                                transcription: messages
                                  .map((arr) => arr.text)
                                  .join(" "),
                              },
                            });
                          }
                        }
                      }}
                      className="flex justify-center items-center"
                      style={{ marginLeft: "10px" }}
                    >
                      <img
                        style={{
                          width: "16px",
                          height: "16px",
                          mixBlendMode: "darken",
                        }}
                        src={AI}
                        alt="Script"
                      ></img>
                    </button>
                  </Tooltip>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flex: 1,
                  fontSize: "15px",
                  fontWeight: "500",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    fontSize: "15px",
                    fontWeight: "500",
                    alignItems: "center",
                  }}
                >
                  Summary
                  <Tooltip content="Copy Summary" direction="top">
                    <button
                      style={{
                        marginLeft: 5,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        border: "none",
                        cursor: "pointer",
                      }}
                      onClick={async () => {
                        document.body.style.cursor = "wait";

                        async function copyToClipboard(text) {
                          try {
                            await navigator.clipboard.writeText(text);
                            toast("Copied to clipboard successfully!!");
                          } catch (err) {
                            console.error("Failed to copy text:", err);
                            toast("Failed to copy text:" + err);
                          }
                        }

                        await copyToClipboard(
                          transcriptDetail.summarizedTranscript
                        );
                        document.body.style.cursor = "default";
                      }}
                    >
                      {" "}
                      <ion-icon
                        name="copy-outline"
                        style={{ fontSize: 16, color: "gray" }}
                      ></ion-icon>
                    </button>
                  </Tooltip>
                  <Tooltip content="Use default Prompt" direction="top">
                    <button
                      onClick={async () => {
                        const data = JSON.parse(
                          localStorage.getItem("defaultPromptNew")
                        );

                        const result = prompts.find((p) => p.id === data.id);

                        if (result) {
                        } else if (prompts.length === 0) {
                          toast("No Default Prompt Found!");
                          return;
                        } else {
                          result = prompts[0];
                        }

                        setInputValue(result.promptText);
                        setFetchSummary(true);
                      }}
                      className="flex justify-center items-center"
                      style={{ marginLeft: "10px" }}
                    >
                      <img
                        style={{ width: "16px", height: "16px" }}
                        src={MagicalIcon}
                        alt="Auto Fill"
                      ></img>
                    </button>
                  </Tooltip>
                </div>
              </div>
            </div>
            {loading ? (
              <div id="svg-container">
                <RotatingLines
                  visible={true}
                  height="96"
                  width="96"
                  color="red"
                  strokeColor="grey"
                  strokeWidth="4"
                  animationDuration="0.75"
                  ariaLabel="rotating-lines-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  height: "90%",
                }}
                className="details-section"
              >
                <div
                  style={{
                    minHeight: "510px",
                    maxHeight: "70vh",
                    overflowY: "auto",
                    padding: "30px 15px",
                    flex: 1,
                    order: "-1",
                  }}
                >
                  {messages.map((m, index) => {
                    return (
                      <div
                        className="message-container"
                        style={{
                          background:
                            m.highlight === true ? "lightyellow" : "white",
                          borderRadius: "10px",
                          position: "relative",
                        }}
                      >
                        {editIdx !== index && (
                          <Highlighter
                            highlightClassName="YourHighlightClass"
                            searchWords={[searchWord]}
                            autoEscape={true}
                            textToHighlight={m.text ? m.text : m}
                          />
                        )}
                        <div
                          style={{
                            display:
                              editIdx === index ? "inline-block" : "none",
                            position: "relative",
                            width: "100%",
                          }}
                        >
                          <textarea
                            value={editValue}
                            onChange={(e) => {
                              setEditValue(e.target.value);
                            }}
                            style={{
                              height: "80px",
                              width: "100%",
                              outline: "none",
                              border: "1px solid gray",
                              padding: "5px",
                              borderRadius: "8px",
                              resize: "none",
                              overflow: "hidden",
                            }}
                          />
                          <button
                            onClick={() => {
                              setEditIdx(null);
                              setEditValue("");
                            }}
                            style={{
                              position: "absolute",
                              bottom: "10px",
                              right: "-40px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              color: "rgb(225, 51, 51)",
                              background: "rgb(255, 245, 245)",
                              border: "1px solid rgb(225, 51, 51)",
                              borderRadius: "5px",
                              cursor: "pointer",
                            }}
                          >
                            <ion-icon
                              name="close-outline"
                              style={{ fontSize: 16 }}
                            ></ion-icon>
                          </button>
                          <button
                            style={{
                              position: "absolute",
                              bottom: "10px",
                              right: "-20px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              color: "rgb(56, 142, 59)",
                              background: "rgb(232, 245, 233)",
                              border: "1px solid rgb(56, 142, 59)",
                              borderRadius: "5px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setEdit({
                                id: location.search.substring(1),
                                index: editIdx,
                                value: editValue,
                              });
                              setEditIdx(null);
                              setEditValue("");
                            }}
                          >
                            <ion-icon
                              name="checkmark-outline"
                              style={{ fontSize: 16 }}
                            ></ion-icon>
                          </button>
                        </div>
                        <div className="editButton">
                          <Tooltip content="Click to edit !!" direction="left">
                            <img
                              src="https://cdn-icons-png.flaticon.com/512/1159/1159633.png"
                              onClick={() => {
                                setEditIdx(editIdx === index ? null : index);
                                setEditValue(m.text);
                              }}
                              style={{ height: 16 }}
                              alt="edit-text"
                            ></img>
                          </Tooltip>
                        </div>
                        {m.highlight === true ? (
                          <div className="highlightButton highlight-active">
                            <Tooltip
                              content="Double click to remove highlight !!"
                              direction="left"
                            >
                              <ion-icon
                                name="bookmarks"
                                onDoubleClick={() => {
                                  setMessages((prevMessages) =>
                                    prevMessages.map((m, idx) => {
                                      if (idx === index) m.highlight = false;
                                      return m;
                                    })
                                  );
                                  setToBeHighlighted(index);
                                }}
                              ></ion-icon>
                            </Tooltip>
                          </div>
                        ) : (
                          <div className="highlightButton">
                            <Tooltip
                              content="Double click to highlight !!"
                              direction="left"
                            >
                              <ion-icon
                                name="bookmarks-outline"
                                onDoubleClick={() => {
                                  setMessages((prevMessages) =>
                                    prevMessages.map((m, idx) => {
                                      if (idx === index) m.highlight = true;
                                      return m;
                                    })
                                  );
                                  setToBeHighlighted(index);
                                }}
                              ></ion-icon>
                            </Tooltip>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
                <div
                  style={{
                    minHeight: "510px",
                    maxHeight: "70vh",
                    overflowY: "auto",
                    padding: "30px 15px",
                    flex: 1,
                  }}
                >
                  {fetchSummary === true ? (
                    <div id="svg-container">
                      <RotatingLines
                        visible={true}
                        height="96"
                        width="96"
                        color="red"
                        strokeColor="grey"
                        strokeWidth="4"
                        animationDuration="0.75"
                        ariaLabel="rotating-lines-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                      />
                    </div>
                  ) : (
                    <>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: 5,
                          marginBottom: 15,
                        }}
                      >
                        <div className="prompt-input-container">
                          <div className="input-wrapper">
                            <input
                              type="text"
                              value={inputValue}
                              onChange={handleInputChange}
                              placeholder='Type a message or type "/" to select a prompt . . . '
                            />
                            {showDropdown && (
                              <div className="dropdown">
                                {prompts.map((prompt, index) => (
                                  <div
                                    key={index}
                                    className="dropdown-item"
                                    onClick={() => handlePromptSelect(prompt)}
                                  >
                                    {prompt.promptName}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            width: "100px",
                            borderRadius: 5,
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer",
                            fontSize: 14,
                            height: 30,
                            background: "white",
                            border: "1px solid rgba(110, 117, 255, 1)",
                            color: "rgba(110, 117, 255, 1)",
                          }}
                          onClick={() => {
                            setFetchSummary(true);
                          }}
                        >
                          Generate
                        </div>
                      </div>
                      {prevChat.map((chat, index) => {
                        return (
                          <div key={index + "-chat"}>
                            {chat.role === "user" ? (
                              <>
                                <div
                                  style={{ color: "grey" }}
                                  dangerouslySetInnerHTML={{
                                    __html: chat.content,
                                  }}
                                />
                                <br></br>
                                <hr></hr>
                                <br></br>
                              </>
                            ) : (
                              <>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: formatText(chat.content),
                                  }}
                                />
                                <br></br>
                              </>
                            )}
                          </div>
                        );
                      })}
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default UploadDetailScreen;
